module.exports = __webpack_public_path__ + "media/applicants/todayshow-7e416591.png";